import service from "@/store/services/communications-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  communication: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, communication) => {
    state.communication = communication;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((communication) => {
      commit("SET_RESOURCE", communication);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((communication) => {
      commit("SET_RESOURCE", communication);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((communication) => {
      commit("SET_RESOURCE", communication);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  communication: (state) => state.communication,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((communication) => ({
      id: communication.id,
      communication_type: communication.communication_type,
    }));
  },
};

const communications = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default communications;
